/**
 * The sub-nav shared by the reconciliation screens: Cash Drop's variance
 * table, Safe Count's list (docs/phases/safe-count.md, section 3), and Petty
 * Cash's ledger (docs/phases/petty-cash-consolidation.md, Part 2).
 *
 * All three entries are always shown, to every account. D-7 means the
 * frontend is never told anyone's role, so there is nothing to hide a link
 * on; each screen renders whatever its endpoint answers, a 403 included.
 */
import { NavLink } from "react-router-dom";

export function ReconciliationNav() {
  return (
    <nav className="subnav" aria-label="Reconciliation views">
      <NavLink to="/reconciliation" end>
        Cash Drop
      </NavLink>
      <NavLink to="/reconciliation/safe-count">Safe Count</NavLink>
      <NavLink to="/reconciliation/petty-cash">Petty Cash</NavLink>
    </nav>
  );
}
